import type { CareOrder } from '@talos/kyoko';
import { mergeWith } from 'lodash-es';
import { stringCareOrderCurrency } from '../../../../../components/OMS/CareOrderFormView/CareOrderSlice';
import type { ImportedCareOrder } from '../types';

/** Just used to show something to the user in the blotter representing the result of a modification action  */
export type ResultingCareOrder = Pick<
  CareOrder,
  | 'OrderID'
  | 'Symbol'
  | 'Side'
  | 'OrderQty'
  | 'Currency'
  | 'OrdStatus'
  | 'status'
  | 'SubmitTime'
  | 'Group'
  | 'Annotations'
  | 'Comments'
  | 'Counterparty'
  | 'SettleDate'
  | 'CptySettlementType'
  | 'units'
>;

export function getResultingCareOrder(
  importedCareOrder: ImportedCareOrder,
  existingCareOrder: CareOrder
): ResultingCareOrder {
  // The imported care order gets precedence
  return {
    OrderID: existingCareOrder.OrderID,
    Symbol: importedCareOrder.Symbol || existingCareOrder.Symbol,
    Currency: stringCareOrderCurrency(importedCareOrder.Currency || existingCareOrder.Currency),
    Side: importedCareOrder.Side || existingCareOrder.Side,
    OrderQty: importedCareOrder.OrderQty || existingCareOrder.OrderQty,
    units: importedCareOrder.units || existingCareOrder.units,
    OrdStatus: existingCareOrder.OrdStatus,
    status: existingCareOrder.status,
    SubmitTime: existingCareOrder.SubmitTime,
    Group: importedCareOrder.Group || existingCareOrder.Group,
    // Recursively merges the properties of Annotations, with importedCareOrder taking precedence.
    // The customizer only applies the || fallback at leaf values. For objects, we return undefined
    // so lodash continues its default deep merge (otherwise the truthy source object short-circuits the recursion).
    Annotations: mergeWith({}, existingCareOrder.Annotations, importedCareOrder.Annotations, (objValue, srcValue) => {
      if (typeof srcValue === 'object' && srcValue !== null) {
        return undefined;
      }
      return srcValue || objValue;
    }),
    Comments: importedCareOrder.Comments || existingCareOrder.Comments,
    Counterparty: importedCareOrder.Counterparty || existingCareOrder.Counterparty,
    SettleDate: importedCareOrder.SettleDate || existingCareOrder.SettleDate,
    CptySettlementType: importedCareOrder.CptySettlementType || existingCareOrder.CptySettlementType,
  };
}
